import type { ApprovalRequestResult } from "@shared/services/salesforce/types";
import type React from "react";
import { setApprovalRequestRecordNameTestId, setApprovalRequestResultLineTestId } from "./approval-request-results.utils";

interface ApprovalRequestResultsProps {
  results?: ApprovalRequestResult[];
}

export const ApprovalRequestResults = ({ results = [] }: ApprovalRequestResultsProps): React.ReactElement => (
  <span>
    {results.map((approvalRequestResult, index) => (
      <span
        key={`${approvalRequestResult.recordId}-${approvalRequestResult.itemNumber}`}
        className="block"
        data-testid={setApprovalRequestResultLineTestId(index)}
      >
        <span data-testid={setApprovalRequestRecordNameTestId(index)}>{approvalRequestResult.recordName}</span>
      </span>
    ))}
  </span>
);
